import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Fade from 'react-reveal/Fade';

import WhatIsNiaVid from '../../static/vid/What_is_NiaUpdated.webm';

const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: '#2f3337',
    // #141414
    position: 'relative',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
    },
    margin: '0 auto',
    marginBottom: theme.spacing(4),
  },
  icon: {
    width: '100px',
    height: 'auto',
    textAlign: 'center',
    margin: theme.spacing(4),
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  sectionHeader: {
    textAlign: 'center',
    color: 'white',
    margin: theme.spacing(4),
    fontSize: 36,
  },
  sectionText: {
    color: 'white',
    marginBottom: theme.spacing(),
  },
  expansionPanel: {
    backgroundColor: '#2f3337',
  },
  action: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  expansionPanelDetails: {
    display: 'block',
  },
  link: {
    textDecoration: 'none',
    color: 'white',
  },
  buttonContainer: {
    padding: theme.spacing(3),
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end',
  },
  video: {
    width: '320px',
    height: 'auto',
    [theme.breakpoints.up(600)]: {
      width: '426px',
      height: '240px',
    },
  },
});

function WhatIsNiaSection(props) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.content}>
        <Fade up>
          <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">WELCOME TO NIA</Typography>
        </Fade>
        <Grid container alignContent="center" justifyContent="space-evenly">
          <Grid item xs={12} md={6} className={classes.itemContainer}>
            <Fade left>
{/*              <iframe
                title="What is Nia?"
                src="https://www.youtube.com/embed/U3rRjq1oaXg"
                className={classes.video}
                frameBorder="0"
                allow="autoplay; fullscreen"
              />*/}
              <video className={classes.video} controls loading="lazy">
                <source src={WhatIsNiaVid} type="video/webm" />
              </video>
            </Fade>
          </Grid>
          <Grid item xs={12} md={6} className={classes.itemContainer}>
            <Fade right>
              <Accordion
                className={classes.expansionPanel}
                elevation={0}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon color="primary" />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.sectionText}>Nia is more than just a workout. It is a holistic fitness practice addressing each aspect of your life - body, mind and soul. Combining dance, martial arts and mindfulness, Nia conditions and strengthens your body while transforming your mind...</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.expansionPanelDetails}>
                  <Typography className={classes.sectionText}>At Nia, we believe every person can discover, explore, unleash, and enhance their individual potential to live a healthy and meaningful life by engaging their senses and listening to their bodies.</Typography>
                  <Typography className={classes.sectionText}>Nia is based on the intelligent design of the body. Each workout combines mindfulness and dynamic movement - leaving you energized, mentally clear, and emotionally balanced.</Typography>
                  <Typography className={classes.sectionText}>Nia workouts combine 52 simple moves with dance arts, martial arts, and healing arts to energize and enliven well-being in 60 minutes - body, mind, emotion, and spirit.</Typography>
                  <Typography className={classes.sectionText}>Nia is non-impact, practiced barefoot, and adaptable to individual needs and abilities. Nia classes are taught by licensed Nia teachers and trainers in dozens of countries and languages across the world.</Typography>
                </AccordionDetails>
              </Accordion>
{/*              <div className={classes.buttonContainer}>
                <a target="_blank" rel="noopener noreferrer" href="https://niaondemand.com/what-is-nia" className={classes.link}>
                  <Button color="primary" className={classes.action} variant="contained">
                    View Examples
                  </Button>
                </a>
                <Button href="/about-nia" color="primary" className={classes.action} variant="contained">More Info</Button>
              </div>*/}
            </Fade>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

WhatIsNiaSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WhatIsNiaSection);
